<template>
  <ModalLayout icon="delete" title="Delete asset?" @close="close">
    Are you sure you want to delete <strong>{{ meta?.asset?.name }}</strong
    >? This action cannot be undone.
    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" @click="ctaDelete" :loading="loading" icon="el-icon-delete" type="danger">Delete</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'DeleteAsset',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async ctaDelete() {
      this.loading = true
      await this.$store.dispatch('socialBoostCampaign/deleteAsset', {
        id: this.$route.params.id,
        flight_id: this.$route.params.flight_id,
        asset_id: this.meta.asset.id,
        redirect: this.meta.redirectTo,
      })
      if (this.meta.redirectTo) {
        this.$router.push(this.meta.redirectTo)
      }
      this.close()
      this.loading = false
    },
  },
}
</script>
